<template>
  <div>
    <div class="header">
      <div style="line-height: 36px">
        <span @click="$emit('collapse')" class="collapse-icon">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </span>
        <span>{{ companyName }}</span>
      </div>
      <div class="header-r">
        <span size="small" style="cursor: pointer" @click="logout">
          <icon-font style="font-size: 24px; color: #9bc7eb" type="tuichu" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    isCollapse: Boolean,
  },
  inject: ["reload"],
  data() {
    return {
      value: [],
      deptOption: [],
      imgerr: true,
      props: {
        label: "Name",
        children: "ManageAreas",
        value: "Id",
      },
    };
  },
  created() {
    // this.getArea();
  },
  mounted() {
    // this.getDept();
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo.userName || {};
    },
    companyName() {
      return "石板滩运维管理系统";
    },
    realName() {
      return this.$store.state.user.userInfo?.realName || "aaa";
    },
    departmentName() {
      return this.$store.state.user.userInfo.departmentName || {};
    },

    positionEnum() {
      return this.$store.state.user.userInfo.positionEnum;
    },

    positionState() {
      return this.$store.state.user.positionState;
    },
    isBindWx() {
      return this.$store.state.user.userInfo?.isBindWx;
    },

    userAvatar() {
      return require("@/assets/user0.png");
    },
    options() {
      return this.$store.state.user.companyAndArea || [];
    },
    isDot() {
      return this.$store.state.user.Unread > 0;
    },
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "修改密码":
          this.$refs.Changepwd.dialogFormVisible = true;
          break;
        case "更新日志":
          window.open("https://cdjdkjgs.space/WebApi/更新日志.pdf");
          break;

        case "操作手册":
          window.open("https://cdjdkjgs.space/WebApi/成都颉达科技企业管理系统操作手册.pdf");
          break;
        case "个人信息":
          this.$refs.UserInfo.open();
          break;
        default:
          break;
      }
    },
    logout() {
      this.$confirm("是否退出系统？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
          });
          this.$store.dispatch("user/logout");
          // this.$store.commit("tree/logout");
          this.$router.push("/login");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //打开消息中心
    MessageCenter() {
      // this.$router.push({
      //   path: "/MessageCenter",
      // });
      this.$refs.Notification.open();
    },
    errEvt() {
      this.imgerr = false;
    },
    //操作手册
    openfile() {
      // window.open(
      //   window.espimp.appconst.baseAPI +
      //     "/Help/企业安全生产智慧管控平台说明书.pdf",
      // );
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  font-size: 16px;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 0 10px;
  // min-width: 1332px;

  .collapse-icon {
    font-size: 26px;
    cursor: pointer;
    vertical-align: bottom;
    color: #3a87e4;
    margin-right: 10px;
  }
  svg {
    color: #3a87e4 !important;
  }
  .product-type {
    display: inline-block;
    border-radius: 50%;
    width: 36px;
    font-size: 14px;
    height: 36px;
    background: #2cbb79;
    color: #ffff;
    vertical-align: top;
    text-align: center;
    margin: 0 10px 0 20px;
  }
  .type-level {
    text-align: center;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 14px;
    color: #ffffff;
    margin-right: 6px;
    &.red {
      background: #ff4343;
    }
    &.warn {
      background: #ffa500;
    }
    &.yellow {
      background: #d5c948;
    }
    &.blue {
      background: #3a87e4;
    }
  }
  .header-r {
    // width: 280px;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
.disDiv {
  display: flex;
  width: 200px;
  border-bottom: 1px solid #d5d5d5;
  img {
    width: 35px;
    position: relative;
    left: 5px;
    top: -5px;
  }
  p {
    padding: 0 10px;
    line-height: 5px;
  }
}
::v-deep .el-dialog {
  border-radius: 12px;
}
::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: solid 2px #e5e5e5;
}
::v-deep .el-dialog__title {
  font-size: 15px;
  color: #666;
  font-weight: bold;
}
.allread {
  color: #3ca1ff;
  z-index: 99;
  margin-right: 100px;
  position: absolute;
  right: 0;
  z-index: 999;
  cursor: pointer;
  top: 10px;
  font-size: 14px;
}
.msglist {
  height: 400px;
  overflow: auto;
}
.msgbox {
  position: relative;
  padding-left: 60px;
  width: 100%;
  height: auto !important;
  .cont {
    display: block;
    margin-left: 53px;
    margin-top: 5px;
    font-size: 15px;
  }
  .levelthree {
    position: absolute;
    top: 24px;
    width: 42px;
    height: 19px;
    font-size: 9px;
    border: solid 1px red;
    border-radius: 12%;
    text-align: center;
    line-height: 19px;
    background: #fef0ef;
    color: #f97379;
  }
  .leveltwo {
    position: absolute;
    top: 24px;
    width: 42px;
    height: 19px;
    font-size: 9px;
    border: solid 1px #d2aef5;
    border-radius: 12%;
    text-align: center;
    line-height: 19px;
    background: #f9f0ff;
    color: #9966de;
  }
  .levelone {
    position: absolute;
    top: 24px;
    width: 42px;
    height: 19px;
    font-size: 9px;
    border: solid 1px #9fdbff;
    border-radius: 12%;
    text-align: center;
    line-height: 19px;
    background: #e6f7ff;
    color: #6fbcff;
  }
  .sure {
    color: #f2c9bf;
    padding: 8px;
  }
  .remind {
    position: absolute;
    top: 58px;
    right: calc(100% - 84%);
    border-radius: 50%;
    display: block;
    width: 7px;
    height: 7px;
    background: red;
  }
  .msgicon {
    margin: 5px 0 10px -50px;
    float: left;
    width: 35px;
    height: 35px;
    font-size: 24px;
    background: #9900cc;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    color: white;
    border: solid 1px #9900cc;
  }
  .contentbox {
    width: 80%;
    border: solid 1px #ccc;
    min-height: 70px;
    border-left: solid 2px #1890ff;
  }
  .msgcon {
    margin: 8px 0 8px 30px;
    display: block;
    font-size: 14px;
    color: #8a8e91;
  }
  .msgsure {
    font-size: 15px;
    color: #b3b3b3;
  }
}
</style>
